<template>
    <svg width="17" height="32" viewBox="0 0 17 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.79315 1.9437L14.4247 14.5753C15.3497 15.5002 15.3497 16.9998 14.4247 17.9247L1.79315 30.5563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "ArrowRightIcon"
    }
</script>

<style scoped>

</style>